import { render, staticRenderFns } from "./TranslationsGroup.vue?vue&type=template&id=17298003"
import script from "./TranslationsGroup.vue?vue&type=script&lang=js"
export * from "./TranslationsGroup.vue?vue&type=script&lang=js"
import style0 from "./TranslationsGroup.vue?vue&type=style&index=0&id=17298003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports